import { useEffect } from 'react'
import { useLocation } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth'
import { useRecentPagesStore } from '@/stores/recentPages'
import { canonicalizePath } from '@/components/Navigation.shared'
import { useSearchableLinks } from './useSearchableLinks'

/**
 * Records a visit to the canonical navigation link matching the current
 * pathname, feeding the "Most used" group in the command palette. No-ops on
 * the login screen and for paths that don't map to a known nav link.
 */
export const useRecordPageVisit = () => {
  const pathname = useLocation({ select: location => location.pathname })
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)
  const searchableLinks = useSearchableLinks()
  const recordVisit = useRecentPagesStore(state => state.recordVisit)

  useEffect(() => {
    if (!isAuthenticated()) return
    const canonical = canonicalizePath(pathname, searchableLinks)
    if (canonical) {
      recordVisit(canonical)
    }
    // searchableLinks is stable per-permissions; pathname change is the trigger.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])
}
